export default {
  "debug": false,
  "dsn": "d9IKwitRrbtC4VQP8lKOsAyCfcI"
}